module.exports = __webpack_public_path__ + "static/media/vscode.46bd07ed.svg";